module.exports = __webpack_public_path__ + "static/media/soundwaves.665f55b3.gif";